import useModal from 'src/components/Modals/hooks/useModal';
import InsuranceFundDetailsModal from 'src/components/Modals/InsuranceFundDetailsModal';

export default function DetailsModals() {
	const { currentModal } = useModal();

	return (
		<>
			{currentModal?.type === 'insurance_fund_details' && (
				<InsuranceFundDetailsModal {...currentModal.props} />
			)}
		</>
	);
}
